import { Route, Routes } from 'react-router-dom'
import { CallsPage } from 'pages/conversations/pages/calls/ui/callsPage'

export const CallsRouter = () => {
  return (
    <Routes>
      <Route path={'/'} element={<CallsPage />} />
    </Routes>
  )
}
